import {useId} from "@react-aria/utils";
import {useTranslation} from "@i18n/client";
import React from "react";

interface TypeFilterProps {
  filters: {[filter: string]: boolean};
  // @ts-expect-error TS7010: 'toggleFilter', which lacks return-type annotation, implicitly has an 'any' return type.
  toggleFilter(filter: string);
}

const TypeFilter: React.FC<TypeFilterProps> = ({filters, toggleFilter}) => {
  const i18n = useTranslation();
  const headingId = useId();

  if (Object.keys(filters).length === 0) return null;

  return (
    <div data-testid="type-filter-container" className="dg gg4 pb12 dn-md">
      <span className="gray600 fs14 lh22 font-im ttu ls12" id={headingId}>
        {i18n.t("Filter By")}
      </span>
      <div role="group" className="df fw gg2" aria-labelledby={headingId}>
        {Object.keys(filters).map((name, k) => (
          <button
            key={k}
            className={`brdn ph3 pv2 font-ib fs14 lh22 br8 contrast-tb cp ${
              filters[name] ? "bg-gray400 gray50 contrast-mark" : "bg-gray100 gray800"
            }`}
            role="switch"
            aria-checked={filters[name]}
            onClick={() => toggleFilter(name)}
          >
            {name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default React.memo(TypeFilter);
